import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("art3d_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
};

export const formatPrice = (v) => {
  const n = Number(v || 0);
  if (!n || n <= 0) return "Preço a definir";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

export const effectivePrice = (p) =>
  p?.promo_price && p.promo_price > 0 ? p.promo_price : p?.price || 0;

export const waNumber = (content) =>
  (content?.contact?.whatsapp || "5584994677862").replace(/\D/g, "");

export const waLink = (content, message) =>
  `https://wa.me/${waNumber(content)}?text=${encodeURIComponent(message)}`;

export const COLOR_HEX = {
  rosa: "#FF69B4",
  pink: "#FF1493",
  roxo: "#9370DB",
  lilás: "#DDA0DD",
  lilas: "#DDA0DD",
  azul: "#00CED1",
  ciano: "#00CED1",
  branco: "#FFFFFF",
  preto: "#1E293B",
  verde: "#34D399",
  amarelo: "#FACC15",
  laranja: "#FB923C",
  vermelho: "#EF4444",
  cinza: "#94A3B8",
  transparente: "#E2E8F0",
};

export const colorHex = (name) =>
  COLOR_HEX[(name || "").trim().toLowerCase()] || "#CBD5E1";

export function formatApiError(err, fallback = "Algo deu errado. Tente novamente.") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}
